export default __webpack_public_path__ + "static/char-v-56-04eb16b83271c0c25057a563b67a6874.webp";